var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnline = function SvgOnline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "online"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1661442
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M4.39152 13.685C3.39459 13.9521 2.80297 14.9769 3.0701 15.9738C3.33722 16.9707 4.36194 17.5623 5.35887 17.2952C4.36194 17.5623 3.77027 18.5869 4.03739 19.5838C4.30452 20.5807 5.32924 21.1723 6.32617 20.9052L7.28262 20.6535L5.31291 13.3024L4.39152 13.685Z",
    fill: "#FFCA90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M14.2256 26.7954C14.398 26.9132 14.5744 27.0247 14.7556 27.1293C16.5608 28.1716 18.7629 28.5249 20.9354 27.9427C25.2801 26.7786 27.8578 22.313 26.6937 17.9684",
    fill: "#FFCA90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M17.3061 3.71902L22.0384 21.3803L18.845 22.236C19.0078 22.4238 19.1864 22.5975 19.3794 22.7546C19.6354 22.9635 19.8248 23.2428 19.9105 23.5626L19.9402 23.6737C20.1598 24.4933 19.6734 25.3359 18.8538 25.5555L9.78465 27.9855C8.97991 28.2012 8.15293 27.7236 7.93746 26.9194L2.76494 7.61531C2.54931 6.81057 3.02669 5.98345 3.83143 5.76782L15.4597 2.65204C16.2633 2.43671 17.0905 2.91428 17.3061 3.71902Z",
    fill: "#405968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screen",
    d: "M4.43451 8.12956L16.146 4.8638L20.3991 20.7365L8.6876 24.0023L4.43451 8.12956Z",
    fill: "#8FD4FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M14.3109 11.4914C13.7701 12.428 14.091 13.6254 15.0276 14.1662L18.6466 16.2558C18.4454 16.5075 18.2668 16.7848 18.1159 17.0866C17.1074 19.1063 17.8637 21.8259 19.7694 23.0364C21.982 24.4417 24.8905 23.7277 26.2138 21.5056C26.8736 20.3977 27.0055 19.1254 26.694 17.9683C26.381 16.8062 25.6212 15.7601 24.4996 15.1127L16.9858 10.7746C16.0492 10.2337 14.8515 10.5546 14.3109 11.4914Z",
    fill: "#FFC994"
  })))));
};
export default SvgOnline;